var Image = (function () {
    function Image() {
    }
    return Image;
}());
export { Image };
